import React from "react";
import { useOfferCard } from "../../../../components/OfferCard/useOfferCard";
import { useInitialOffer } from "../../../InitialOffer/useInitialOffer";
import { ReviewAssumptions } from "../../../../components";
import { WhatHappensNextModal } from "../WhatHappensNextModal";
import { openWhatHappensNextModal } from "../../../helpers";
import { WhatHappensNextCTA } from "../WhatHappensNextCTA";
import { PromoReminder } from "../../../InitialOffer/components";
import { PromoApplied } from "../../../InitialValuation/components/PromoApplied";
import { useLocation } from "react-router-dom";
import PromoTicker from "../../../InitialOffer/components/PromoTicker";

export const OfferCardPartExchange = ({
  handleApplyPromo,
  onSubmit,
  showLoader,
  showSpinner,
  startTicker
}) => {
  const {
    valuation,
    promoApplied,
    EstimatedOfferCopy,
    offerCardNoValuationSecondaryText,
    noPromo
  } = useOfferCard();

  const {
    promoActionNotRequired,
    happensNextCardRef,
    showBranchValuationContent,
    showEstimatedOfferPartExchange,
    reuseAppraisalPromo,
    estimatedOfferCTA,
    estimatedOfferNoValuationCTACopy
  } = useInitialOffer();

  const location = useLocation();
  const pathname = location.pathname;

  return (
    <>
      <div className="ch-card ch-pa--3 sm:ch-pa--5 ch-display--flex ch-flex-flow--column-nowrap ch-align-items--center ch-pb--1 initial-offer-card-part-exchange part-exchange-card-border--top-card ch-shadow--sm ch-mb--4">
        <div
          className={`${promoApplied && !showLoader ? "promo-fade-in" : ""} ch-width--12`}
        >
          {!valuation ? (
            <div className="ch-pa--1">
              <p className="ch-fs--3 ch-text--bold ch-text--center">
                Sorry, we’re unable to offer an online valuation for this
                vehicle
              </p>
              {offerCardNoValuationSecondaryText && (
                <p className="ch-fs--2 ch-text--center ch-mb--0">
                  {offerCardNoValuationSecondaryText}
                </p>
              )}
              <div className="ch-mt--4">
                <button
                  className={`ch-btn ch-btn--success ch-display--flex ch-width--12 ${
                    showSpinner ? "ch-btn--loading" : ""
                  }`}
                  type="button"
                  onClick={() => onSubmit(pathname)}
                  data-testid="estimated-offer-no-valuation-cta"
                >
                  {estimatedOfferNoValuationCTACopy}
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="ch-text--center ch-width--12">
                {(promoApplied || reuseAppraisalPromo) && !showLoader && (
                  <PromoApplied
                    promotionalBonus={valuation?.promotionalBonus}
                  />
                )}

                <p className="ch-fs--4 sl:ch-fs--5 ch-mb--0 ch-text--center">
                  {EstimatedOfferCopy}
                </p>

                <p
                  className={`offer-price ${noPromo ? "" : "space-numbers-evenly"} ch-text--bold ch-mb--1`}
                >
                  <span>£</span>

                  {promoApplied || reuseAppraisalPromo ? (
                    valuation?.valuation.toLocaleString()
                  ) : promoActionNotRequired ? (
                    valuation?.valuationBeforePromotion.toLocaleString()
                  ) : (
                    <PromoTicker
                      startTicker={startTicker}
                      valuationBeforePromo={valuation?.valuationBeforePromotion}
                      valuationAfterPromo={valuation?.valuation}
                    />
                  )}

                  {(!promoActionNotRequired || showBranchValuationContent) && (
                    <span>*</span>
                  )}
                </p>

                {(promoApplied || reuseAppraisalPromo) &&
                  valuation?.promotionAppliedToValuation && (
                    <p
                      className={`ch-text--capitalize ch-mb--0 price-no-promo ch-text--bold ${showBranchValuationContent ? "ch-mb--2" : ""}`}
                    >
                      was £
                      {valuation?.valuationBeforePromotion.toLocaleString()}
                    </p>
                  )}
              </div>
              {showLoader ? (
                <div
                  className="ch-skeleton ch-mt--3"
                  style={{ height: "200px" }}
                />
              ) : (
                <>
                  {!promoActionNotRequired && (
                    <>
                      <PromoReminder
                        promotionalBonus={valuation?.promotionalBonus}
                        handleApplyPromo={handleApplyPromo}
                      />
                    </>
                  )}
                  {(promoActionNotRequired && !showBranchValuationContent) ||
                  (!promoActionNotRequired && promoApplied) ? (
                    <hr className="ch-mv--3 ch-width--12 ch-bg--grey-3" />
                  ) : null}
                  {promoActionNotRequired && <ReviewAssumptions />}
                  <>
                    {showBranchValuationContent && promoActionNotRequired && (
                      <button
                        className={`ch-btn ch-btn--success ch-display--flex ch-width--12 ch-mt--2 ${
                          showSpinner ? "ch-btn--loading" : ""
                        }`}
                        type="button"
                        onClick={() => onSubmit(pathname)}
                        data-testid="initial-offer-cta"
                      >
                        {estimatedOfferCTA}
                      </button>
                    )}
                  </>

                  {promoActionNotRequired &&
                    !showBranchValuationContent &&
                    showEstimatedOfferPartExchange && (
                      <div className="ch-mt--2">
                        <WhatHappensNextCTA
                          handleClick={openWhatHappensNextModal}
                          happensNextCardRef={happensNextCardRef}
                        />
                        <WhatHappensNextModal
                          happensNextCardRef={happensNextCardRef}
                        />
                      </div>
                    )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
